module.exports = __webpack_public_path__ + "img/bbbb2.6cc1e128.png";